import { SSAPI_PROXY_BASE_URL } from 'config/constants';
import { ScopedURLBuilder } from 'utils/linkUtils';

const builder = new ScopedURLBuilder(SSAPI_PROXY_BASE_URL);

export const trending = {
  topics: builder.createAPICall('trending/businessProfile/:businessProfileId/topics'),
};
